module.exports = __webpack_public_path__ + "img/learn_balloon2_sp.b65e9516.svg";